import React, { Component } from 'react'
import { observer } from 'mobx-react'
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { IconeCarregar } from '../../comum/components/Icones';

@observer
export default class TabelaVeicCdta extends Component {

    constructor(props) {
        super(props)

        this.controller = this.props.controller
    }

    render() {
        return (
                this.controller.loadingListaAguard
                ?
                <IconeCarregar tamanho="2x" />
                :
                <div>
                    <ToolkitProvider
                        keyField="AppointmentNbr"
                        data={[...this.controller.itens]}
                        columns={[...this.controller.colunas]}
                        search
                    >
                        {props =>
                            <div>
                                <BootstrapTable bootstrap4
                                    striped
                                    bordered={false}
                                    noDataIndication={"Nenhum registro encontrado."}
                                    classes="tabela"
                                    //expandRow={detalhesRow}
                                    {...props.baseProps} 
                                />
                            </div>
                        }
                    </ToolkitProvider>
                </div>
            )
        }
    }



// WEBPACK FOOTER //
// ./src/modules/veiculoscdta/components/TabelaVeicCdta.js